import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const ButtonGroup = styled.div`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    position: absolute;
    top: ${kcc.size.S200}px;
    right: ${kcc.size.S200}px;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: ${kcc.spacing.SM};
  `}
`;

export const ToggleButton = styled.button<{ $isActive: boolean }>`
  ${({ theme: { kcc }, $isActive }): FlattenSimpleInterpolation => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: ${kcc.size.S600}px;
    height: ${kcc.size.S600}px;
    padding: 0;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: ${$isActive ? kcc.colors.WHITE : kcc.colors.TEXT};
    background-color: ${$isActive ? kcc.colors.GRAY_950 : kcc.colors.WHITE};

    /* Beep / Blink SVGs use a hardcoded dark fill */
    .svg-icon svg path {
      fill: ${$isActive ? kcc.colors.WHITE : kcc.colors.TEXT};
    }

    &:focus-visible {
      outline: 2px solid ${kcc.colors.BLUE[500]};
      outline-offset: 2px;
    }

    &:disabled {
      cursor: not-allowed;
      color: ${kcc.colors.TEXT_DISABLED};

      .svg-icon svg path {
        fill: ${kcc.colors.TEXT_DISABLED};
      }
    }
  `}
`;

export const ActiveIndicator = styled.span`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    position: absolute;
    top: 50%;
    right: 6px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    transform: translateY(-50%);
    background-color: ${kcc.colors.BLUE[400]};
  `}
`;
